<mat-expansion-panel *ngIf="searchEnabled" class="mb-3" #search>
  <mat-expansion-panel-header>
    <mat-panel-title>Recherche</mat-panel-title>
  </mat-expansion-panel-header>
  <div [formGroup]="searchForm" class="form-group row">
    <mat-form-field class="col-12 col-lg-4" id="searchAddress">
      <mat-label>Rechercher une adresse</mat-label>
      <input matInput placeholder="" type="text" #searchAddress (keyup.enter)="doSearchAddress($event.target.value)" />
      <button mat-button *ngIf="searchAddress.value" matSuffix aria-label="Valider" appTooltip="Valider" (click)="doSearchAddress(searchAddress.value)">
        <mat-icon color="primary" aria-label="Valider">check</mat-icon>
      </button>
    </mat-form-field>

    <app-input [label]="'Rechercher une propriété'" [formControl]="form_searchTerm" [size]="4" [autocompletionType]="'properties'" [hasDeleteBtn]="false" (clickedOption)="onPropertyFound($event)"></app-input>
  </div>

</mat-expansion-panel>
